module.exports = __webpack_public_path__ + "static/994f53.png";